export const CLEAR_PARCEL = "CLEAR_PARCEL"
export const GET_PARCEL = "GET_PARCEL"
export const GET_PARCEL_FAILURE = "GET_PARCEL_FAILURE"
export const GET_PARCEL_REQUEST = "GET_PARCEL_REQUEST"
export const GET_PARCEL_SUCCESS = "GET_PARCEL_SUCCESS"
export const GET_PARCEL_CANCEL = "GET_PARCEL_CANCEL"

export const CLEAR_PARCELS = "CLEAR_PARCELS"
export const GET_PARCELS = "GET_PARCELS"
export const GET_PARCELS_FAILURE = "GET_PARCELS_FAILURE"
export const GET_PARCELS_REQUEST = "GET_PARCELS_REQUEST"
export const GET_PARCELS_SUCCESS = "GET_PARCELS_SUCCESS"
export const GET_PARCELS_CANCEL = "GET_PARCELS_CANCEL"



// WEBPACK FOOTER //
// ./src/data/constants/index.js